import React from 'react';
import { useContext } from 'react';
import {
  Button,
  DataGrid,
  Text,
  useResponsiveParams,
} from 'quanta-ui';
// import { GET_PCV_POLICY_VAR_DETAILS } from '../../queries';
import { GET_MISCD_POLICY_VAR_DETAILS } from '../../queries';

import { useQuery } from '@apollo/client';
import {Loading} from 'quanta-flows/modules/layout';
import {Error} from 'quanta-flows/modules/layout';
// import { updateMotorQuote } from '../../_graphql/state';
import { updateMotorQuote } from 'quanta-flows/modules/quote/motor/state';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import { QuantaConfigContext } from 'quanta-flows';
import { CurrencyFormater } from 'quanta-flows';
export default function QuoteData({ 
  goToStep, 
  productCode,
  productName,
  lobCode,
  lobName,
  quoteNumber,
  modify,
  ...props
}) {
  let repeatForMobile = 1;
  let repeatForDesktop = 3;
  let repeat = useResponsiveParams({
    for_mobile: repeatForMobile,
    for_desktop: repeatForDesktop,
  });

  let {
    loading,
    error,
    data: state,
  } = useQuery(GET_MISCD_POLICY_VAR_DETAILS);
  if (loading) return <Loading />;
  if (error) return <Error error={error} />;
   const { branding } = useContext(QuantaConfigContext);
  let { motorQuote } = state;
  let data = [
    {
      label: 'Vehicle Details (Make, Model, Variant, Fuel Type, Cubic Capacity)',
      colSpan: 2,
      text: (
        <Text>
          {[
            motorQuote?.make?.value?.trim(),
            motorQuote?.model?.value?.trim(),
            motorQuote?.variant?.value?.trim(),
            motorQuote?.fuelType,
            motorQuote?.cubeCapacity,
          ]
            .filter((a) => a)
            .join(', ') ? (
            [
              motorQuote?.make?.value?.trim(),
              motorQuote?.model?.value?.trim(),
              motorQuote?.variant?.value?.trim(),
              motorQuote?.fuelType,
              motorQuote?.cubeCapacity,
            ]
              .filter((a) => a)
              .join(', ')
          ) : (
            <Text severity="neutral">{'Not Captured'}</Text>
          )}
        </Text>
      ),
    },
    {
      label: 'Date of Registration/Purchase',
      className: repeat === repeatForMobile?'':'ml-2',
      text: (
        <Text>
          {[
            motorQuote?.dateOfReg?.trim(),
            motorQuote?.rtoAuthorityCode?.trim(),
            motorQuote?.rtoLocationDesc,
          ]
            .filter((a) => a)
            .join(', ') ? (
            [
              motorQuote?.dateOfReg?.trim(),
              motorQuote?.rtoAuthorityCode?.trim(),
              motorQuote?.rtoLocationDesc,
            ]
              .filter((a) => a)
              .join(', ')
          ) : (
            <Text severity="neutral">{'Not Captured'}</Text>
          )}
        </Text>
      ),
    },
    {
      label: 'Previous Insurance',
      colSpan: 2,
      text: (
        <Text>
          {[
          motorQuote?.anyPreviousPolicyforVehicleTaken ==='Yes'?( motorQuote?.policyCoverType?.trim(),
            motorQuote?.policyExpiryDate?.trim(),
            motorQuote?.previousYearNCBSlab):''
          ]
            .filter((a) => a)
            .join(', ') ? (
            [
              motorQuote?.policyCoverType=='Act Only'?
              'Liability Only'
              : 
              motorQuote?.policyCoverType?.trim(),
              motorQuote?.policyExpiryDate?.trim(),
              motorQuote?.previousYearNCBSlab,
            ]
              .filter((a) => a)
              .join(', ')
          ) : (
            <Text severity="neutral">
              {motorQuote?.businessType?.toLowerCase() ===
              'new business'
                ? 'NA'
                : 'Not Captured'}
            </Text>
          )}
          {motorQuote?.previousYearNCBSlab && motorQuote?.anyPreviousPolicyforVehicleTaken==='Yes' ? '%' : null}
        </Text>
      ),
    },
    {
      label: ``,
      className: repeat === repeatForMobile?'':'ml-2',
      text: (
        <div className="flex flex-col items-baseline h-full">
          {!motorQuote?.quotationNo &&
          <Button
            flat={true}
            className="md:w-48"
            disabled={
              props?.forwardedCoversFormRef?.current?.values
                ?.isQuoteSaving ||
              props?.forwardedCoversFormRef?.current?.values
                ?.isQuoteSaved ||
              props?.forwardedCoversFormRef?.current?.values
                ?.isPremiumLoading
            }
            onClick={(e) => {
              goToStep(0);
              updateMotorQuote({
                ...motorQuote,
                currentTab: 'vehicle',
                isPremiumCalculating: null,
              });
            }}
            iconPre={<FontAwesomeIcon icon={faChevronLeft} className={repeat === repeatForMobile?'mr-2':''}/>}
          >
            Change
          </Button>}
          {motorQuote?.quotationNo &&
            <Button
              flat={true}
              className="md:w-48"
              onClick={(e) => {
                goToStep(0);
              }}
              iconPre={<FontAwesomeIcon icon={faChevronLeft} className={`-ml-1 ${repeat === repeatForMobile?'mr-2':''}`}/>}
            >
              View Vehicle Details
            </Button>
          }
        </div>
      ),
    },
    // productCode?.toString()!=='3129'||
    motorQuote?.productVariant?.toLowerCase()?.search('liability') === -1
    ?
    {
      label: 'First Year Insured Declared Value(IDV)',
      colSpan: 2,
      text: /*{
        <CountAnimation
         end={parseFloat(
           premiumData?.calculatePremiumQuoteCarSecure?.idv1,
         )}
         duration={1}
         decimals={2}
         prefix={branding.currency + ' '}
         formattingFn={(num) => {
           return Parse(num, true, false, branding, true);
         }}
       /> 
     }*/ 
     motorQuote?. premiumData?.idv1 !==
    null &&
    motorQuote?. premiumData?.idv1  !==
    undefined &&
    motorQuote?. premiumData?.idv1  !== ''
    ?`${CurrencyFormater(
     parseFloat(
        motorQuote?. premiumData?.idv1,
     ),
     true,
     false,
     branding,
     true,
   )}`
   :'Not Captured',
    }:null,

    motorQuote?. premiumData?.vehicleAge !==
    null &&
    motorQuote?. premiumData?.vehicleAge  !==
    undefined &&
    motorQuote?. premiumData?.vehicleAge  !== ''
    ? {
      label: 'Vehicle Age',
      text: 
      `${motorQuote?.premiumData?.vehicleAge} year(s)`,
    }
    : {
      label: 'Vehicle Age',
      text: 
      `Not Captured`,
    },
  ].filter((a) => a)


  return (
    <DataGrid
      gap={2}
      gapY={6}
      repeat={repeat}
      data={data}
      textType="normal"
      nullData={() => {
        return (
          <Text type="normal" severity="neutral">
            Not Captured
          </Text>
        );
      }}
    />
  );
}
